import React, { useState } from "react";
import "@/App.css";
import { translations } from "./translations";
import { Header } from "./components/Header";
import { Hero } from "./components/Hero";
import { ReputationalRiskSection } from "./components/ProblemSection";
import { OperationalFramework } from "./components/OperationalFramework";
import { CapabilityProof } from "./components/CapabilityProof";
import { MethodSection } from "./components/ProcessSection";
import { WhySection } from "./components/WhySection";
import { WhenSection } from "./components/WhenSection";
import { ContactSection } from "./components/ContactSection";
import { Footer } from "./components/Footer";
import { CookieBanner } from "./components/CookieBanner";

function App() {
  const [currentLanguage, setCurrentLanguage] = useState('en');
  const t = translations[currentLanguage];

  const scrollToContact = () => {
    const element = document.getElementById('contact');
    if (element) {
      const offset = 80;
      const elementPosition = element.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - offset;
      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      });
    }
  };

  return (
    <div className="App">
      <Header 
        currentLanguage={currentLanguage}
        onLanguageChange={setCurrentLanguage}
        t={t}
      />
      <Hero onContactClick={scrollToContact} t={t} />
      <ReputationalRiskSection t={t} />
      <OperationalFramework t={t} />
      <CapabilityProof t={t} />
      <MethodSection t={t} />
      <WhySection t={t} />
      <WhenSection t={t} />
      <ContactSection t={t} />
      <Footer t={t} />
      <CookieBanner t={t} />
    </div>
  );
}

export default App;

